<div class="container">
	<div class="content">
		<ng-container *ngIf="!isMobile else mobileBreadcrumbs">
			<div class="breadcrumbs">
				<a class="breadcrumbs-element" routerLink="">{{ 'breadcrumbs.home' | translate }}</a>
				<mat-icon class="breadcrumbs-chevron" svgIcon="chevron-left"></mat-icon>
				<p class="breadcrumbs-element-current">{{ 'about.title' | translate }}</p>
			</div>
		</ng-container>
		
		<ng-template #mobileBreadcrumbs>
			<div class="breadcrumbs">
				<mat-icon class="breadcrumbs-chevron" svgIcon="chevron-left" color="accent"></mat-icon>
				<a class="breadcrumbs-element-mobile" routerLink="">{{ 'breadcrumbs.home' | translate }}</a>
			</div>
		</ng-template>
	
		<div class="menu-about-map">
			<ng-container *ngIf="!isMobile else menuMobile">
				<div class="menu">
					<p class="menu-title">{{ 'about.menu.title' | translate }}</p>
					<a class="menu-option" routerLink="../../carte">{{ 'about.menu.map' | translate }}</a>
					<a class="menu-option" routerLink="../../stations">Stations</a>
                    <div class="training-header-no-border menu-selected"
						(click)="trainingOptionsShown = !trainingOptionsShown">
						<p class="training-header-title">{{ 'about.menu.training.title' | translate }}</p>
						<mat-icon color="primary">{{ !trainingOptionsShown ? 'expand_more' : 'expand_less' }}</mat-icon>
					</div>
					<div *ngIf="trainingOptionsShown"
						class="training-options">
						<a class="training-option" routerLink="../../formations/module-1">{{ 'about.menu.training.module1' | translate }}</a>
						<p class="training-option-selected">{{ 'about.menu.training.module2' | translate }}</p>
						<a class="training-option" routerLink="../../formations/module-3">{{ 'about.menu.training.module3' | translate }}</a>
						<a class="training-option" routerLink="../../formations/module-4">{{ 'about.menu.training.module4' | translate }}</a>
						<a class="training-option" routerLink="../../formations/module-5">{{ 'about.menu.training.module5' | translate }}</a>
					</div>
				</div>
			</ng-container>
			<ng-template #menuMobile>
				<div class="menu-mobile">
					<div class="menu-mobile-header"
						(click)="menuShown = !menuShown">
						<p class="menu-mobile-header-label">{{ 'about.menu.title' | translate }}</p>
						<mat-icon color="primary">{{ !menuShown ? 'expand_more' : 'expand_less' }}</mat-icon>
					</div>
					<div *ngIf="menuShown" class="menu-mobile-options">
                        <a class="menu-mobile-option" routerLink="../../carte">{{ 'about.menu.map' | translate }}</a>
						<a class="menu-mobile-option" routerLink="../../stations">Stations</a>
                        <div class="training-header"
							(click)="trainingOptionsShown = !trainingOptionsShown">
							<p class="menu-mobile-option-selected">{{ 'about.menu.training.title' | translate }}</p>
							<mat-icon color="primary">{{ !trainingOptionsShown ? 'expand_more' : 'expand_less' }}</mat-icon>
						</div>
						<div *ngIf="trainingOptionsShown"
							class="training-options">
							<a class="training-option" routerLink="../../formations/module-1">{{ 'about.menu.training.module1' | translate }}</a>
							<p class="training-option-selected training-option-selected-mobile">{{ 'about.menu.training.module2' | translate }}</p>
							<a class="training-option" routerLink="../../formations/module-3">{{ 'about.menu.training.module3' | translate }}</a>
							<a class="training-option" routerLink="../../formations/module-4">{{ 'about.menu.training.module4' | translate }}</a>
							<a class="training-option" routerLink="../../formations/module-5">{{ 'about.menu.training.module5' | translate }}</a>
						</div>
					</div>
				</div>
			</ng-template>
			<div class="about-map">
				<h1>{{ 'about.training.module2.title' | translate }}</h1>
				
				<h2>{{ 'about.training.module2.section1.title' | translate }}</h2>
				<p>{{ 'about.training.module2.section1.part1' | translate }}</p>
				<p>{{ 'about.training.module2.section1.part2' | translate }}</p>
				<img class="image" src="assets/images/about/module2/M2_Infographie_processus_environnementaux_v4.png">
				<p>{{ 'about.training.module2.section1.part3' | translate }}</p>
				<p>{{ 'about.training.module2.section1.part4' | translate }}</p>

				<h2>{{ 'about.training.module2.section2.title' | translate }}</h2>
				<p>{{ 'about.training.module2.section2.intro' | translate }}</p>
				<img class="image" src="assets/images/about/module2/M2_Infographie_etapes_prevision_inondations_v3.png">

				<h3>{{ 'about.training.module2.section2.subsection1.title' | translate }}</h3>
				<p>{{ 'about.training.module2.section2.subsection1.text' | translate }}</p>
				<div class="info">
					<div class="info-left">
						<mat-icon class="info-icon" svgIcon="information-outline"></mat-icon>
					</div>
					<div class="info-right">
						<p class="info-text"><b>{{ 'about.training.module2.section2.subsection1.info.title' | translate }}</b></p>
						<p class="info-text" [innerHtml]="'about.training.module2.section2.subsection1.info.text' | translate"></p>
					</div>
				</div>

				<h3>{{ 'about.training.module2.section2.subsection2.title' | translate }}</h3>
				<p>{{ 'about.training.module2.section2.subsection2.text' | translate }}</p>
				<div class="info">
					<div class="info-left">
						<mat-icon class="info-icon" svgIcon="information-outline"></mat-icon>
					</div>
					<div class="info-right">
						<p class="info-text"><b>{{ 'about.training.module2.section2.subsection2.info.title' | translate }}</b></p>
						<p class="info-text" [innerHtml]="'about.training.module2.section2.subsection2.info.text' | translate"></p>
					</div>
				</div>

				<h3>{{ 'about.training.module2.section2.subsection3.title' | translate }}</h3>
				<p>{{ 'about.training.module2.section2.subsection3.text' | translate }}</p>

				<h2>{{ 'about.training.module2.section3.title' | translate }}</h2>
				<p>{{ 'about.training.module2.section3.part1' | translate }}</p>
				<p>{{ 'about.training.module2.section3.part2' | translate }}</p>
				<p>{{ 'about.training.module2.section3.part3' | translate }}</p>
				<p>{{ 'about.training.module2.section3.part4' | translate }}</p>
				<p>{{ 'about.training.module2.section3.part5.subpart1' | translate }}
					<a class="link" href="https://www.quebec.ca/securite-situations-urgence/urgences-sinistres-risques-naturels/quoi-faire-avant-pendant-apres-urgence-sinistre/inondation" target="_blank">{{ 'about.training.module2.section3.part5.subpart2' | translate }}
						<mat-icon class="link-icon">open_in_new</mat-icon>
					</a>
					{{ 'about.training.module2.section3.part5.subpart3' | translate }}
				</p>

				<div id="evaluation">
					<h2 class="evaluation-title">{{ 'about.training.evaluation.title' | translate }}</h2>
					<div class="question">
						<p class="question-question">{{ 'about.training.module2.evaluation.question1.question' | translate }}</p>
						<mat-radio-group class="question-options">
							<mat-radio-button class="question-option" value="a">{{ 'about.training.module2.evaluation.answers.a' | translate }}</mat-radio-button>
							<mat-radio-button class="question-option" value="b">{{ 'about.training.module2.evaluation.answers.b' | translate }}</mat-radio-button>
							<mat-radio-button class="question-option" value="c">{{ 'about.training.module2.evaluation.answers.c' | translate }}</mat-radio-button>
						</mat-radio-group>
						<div *ngIf="showAnswers" class="answer-box">
							<div class="answer">
								<p class="answer-answer">{{ 'about.training.evaluation.answer' | translate }} :&nbsp;
									<span class="answer-answer-true">{{ 'about.training.module2.evaluation.answers.a' | translate }}</span>
								</p>
							</div>
							<p class="answer-description">{{ 'about.training.module2.evaluation.question1.answer' | translate }}</p>
						</div>
					</div>
					<div class="question">
						<p class="question-question">{{ 'about.training.module2.evaluation.question2.question' | translate }}</p>
						<mat-radio-group class="question-options">
							<mat-radio-button class="question-option" value="a">{{ 'about.training.module2.evaluation.answers.a' | translate }}</mat-radio-button>
							<mat-radio-button class="question-option" value="b">{{ 'about.training.module2.evaluation.answers.b' | translate }}</mat-radio-button>
							<mat-radio-button class="question-option" value="c">{{ 'about.training.module2.evaluation.answers.c' | translate }}</mat-radio-button>
						</mat-radio-group>
						<div *ngIf="showAnswers" class="answer-box">
							<div class="answer">
								<p class="answer-answer">{{ 'about.training.evaluation.answer' | translate }} :&nbsp;
									<span class="answer-answer-true">{{ 'about.training.module2.evaluation.answers.c' | translate }}</span>
								</p>
							</div>
							<p class="answer-description">{{ 'about.training.module2.evaluation.question2.answer' | translate }}</p>
						</div>
					</div>
					<div class="question">
						<p class="question-question">{{ 'about.training.module2.evaluation.question3.question' | translate }}</p>
						<mat-radio-group class="question-options">
							<mat-radio-button class="question-option" value="a">{{ 'about.training.module2.evaluation.answers.a' | translate }}</mat-radio-button>
							<mat-radio-button class="question-option" value="b">{{ 'about.training.module2.evaluation.answers.b' | translate }}</mat-radio-button>
							<mat-radio-button class="question-option" value="c">{{ 'about.training.module2.evaluation.answers.c' | translate }}</mat-radio-button>
						</mat-radio-group>
						<div *ngIf="showAnswers" class="answer-box">
							<div class="answer">
								<p class="answer-answer">{{ 'about.training.evaluation.answer' | translate }} :&nbsp;
									<span class="answer-answer-true">{{ 'about.training.module2.evaluation.answers.b' | translate }}</span>
								</p>
							</div>
							<p class="answer-description">{{ 'about.training.module2.evaluation.question3.answer' | translate }}</p>
						</div>
					</div>
					<button *ngIf="!showAnswers" class="show-answer" (click)="showAnswers = true">{{ 'about.training.evaluation.submit' | translate }}</button>
				</div>
				<br>
				<app-shared-sequential-links
					[previousLinkText]="'about.training.module1.title' | translate"
					previousLinkUrl="/en-savoir-plus/formations/module-1"
					[nextLinkText]="'about.training.module3.title' | translate"
					nextLinkUrl="/en-savoir-plus/formations/module-3">
				</app-shared-sequential-links>
			</div>
		</div>
		<app-shared-footer class="footer"></app-shared-footer>
	</div>
</div>
